/*! @azure/msal-common v11.0.0 2023-03-07 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "11.0.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
